import type { ZoneDetailTypes } from "../lib/apis/dtos/response/category.response";

interface ConvertedZone {
  zoneId: number;
  name: string;
}

export const convertRegionData = (data: ZoneDetailTypes[]): ConvertedZone[] => {
  return data.flatMap((region) =>
    region.zoneItems.map((zone) => ({
      zoneId: zone.zoneId,
      name: `${region.regionName} ${zone.zoneName}`,
    }))
  );
};